// extracted by mini-css-extract-plugin
export default {"wrapper":"BadgeWithLabel_wrapper__v-M2t","text":"BadgeWithLabel_text__skUmL","label":"BadgeWithLabel_label__ZwLF7"};